// ============================================================
// useConditionNumberPicker - the Add-Condition picker's number state
// ============================================================
// Which condition's number picker is open, the custom figure being typed,
// and Hallucinating's hold rounds. Adding a number closes the picker and
// clears both inputs; opening one clears only the custom figure, so a hold
// typed and abandoned is still there next time (as it always was).

import { useState } from 'react';
import type { EligibleCondition } from '../engine/conditionEligibility';
import { numberedCode, toggledCode } from './conditionPicker';

/** The number picker's state and verbs, owned by AddConditionModal. */
export interface ConditionNumberPicker {
  /** The code whose picker is open, or null. */
  openFor: string | null;
  custom: string;
  setCustom: (value: string) => void;
  holdRounds: string;
  setHoldRounds: (value: string) => void;
  /** Open this code's picker, or close it if it is the one open. */
  toggle: (code: string) => void;
  close: () => void;
  /** Add `cond` with the number `n` and close the picker. */
  add: (cond: EligibleCondition, n: number) => void;
}

export function useConditionNumberPicker(onAdd: (code: string) => void): ConditionNumberPicker {
  const [openFor, setOpenFor] = useState<string | null>(null);
  const [custom, setCustom] = useState('');
  // Hallucinating only (v8.359.0): '' = steps down; N = holds N rounds; 0 = until removed.
  const [holdRounds, setHoldRounds] = useState('');

  const toggle = (code: string) => {
    setOpenFor(toggledCode(openFor, code));
    setCustom('');
  };
  const add = (cond: EligibleCondition, n: number) => {
    onAdd(numberedCode(cond, n, holdRounds));
    setOpenFor(null);
    setCustom('');
    setHoldRounds('');
  };
  return { openFor, custom, setCustom, holdRounds, setHoldRounds, toggle, close: () => setOpenFor(null), add };
}
